import axios from "axios";
import { url } from "./url.service";

const serverUrl = url + "/meeshoPdf";

export const uploadMeeshoPdf = (formData) => {
    return axios.post(serverUrl + "/uploadMeshoPdf", formData);
};

